<template>  
  <div class="merchipctrl">    
    <el-select :size="slsize" v-model="slvl" clearable style="width: 100%;" :placeholder="$t('app_select')" @change="onChange">
      <el-option
        v-for="item in tableData"
        :key="item.merchantId"
        :label="item.merchantName"
        :value="item.merchantId">
      </el-option>
    </el-select>
  </div>
</template>

<script>
export default {  
  data () {
    return { 
      tableData: [],
      slvl: '',
      slsize: ''
    }
  },
  // value size两个值，callback回调选择的值
  props: ['config'],
  watch: {
    config (n) {      
      this.slsize = n.size
      this.slvl = n.value            
      this.getList()
    }
  },
  methods: {
    onChange (vl) {
      if (this.config.callback) {        
        this.config.callback(vl)
      }
    },
    getList () { 
		var merchantId = ''
		var agentId = ''
		var merchantName = ''
		this.$merchList(1, 99999, merchantId, agentId, merchantName, res => {        
		  if (res.status == 200) {                 
		    this.tableData = res.data
		  }
		}, '')
    }
  },
  mounted () {
    ///// init
    if (this.config) {
      this.slvl = this.config.value
      this.slsize = this.config.size      
    }    
    this.getList()
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .merchipctrl {
    width: 100%;
  }
</style>
